import Page from "webPage/Page";
import Track from "util/Track";
import ScrollMagic from "scrollmagic";
import {Power0, TimelineMax, TweenMax} from "gsap";
import {createController, registerScene, sectionGetHeight} from "../util/parallax";

Page.register('page-template-why-3sk', () => {
    let $track = $(".js-track-wrap");

    if ($track.length > 0) {
        new Track($track, {
            classes: {
                block: "card-slider",
            },
        });
    }

    createController();

    registerScene(new ScrollMagic.Scene({
        triggerElement: '.hero',
        duration: sectionGetHeight('.hero'),
        triggerHook: "onEnter",
    }).setTween(new TimelineMax().add([
        TweenMax.fromTo('.js-hero-image', 1, {y: -5}, {y: 5, ease: Power0.easeNone}),
    ])));

    registerScene(new ScrollMagic.Scene({
        triggerElement: '.section--under-hero',
        duration: sectionGetHeight('.section--under-hero'),
        triggerHook: "onEnter",
    }).setTween(new TimelineMax().add([
        TweenMax.fromTo('.js-circle-green-1', 1, {y: 0}, {y: 500, ease: Power0.easeNone}),
        TweenMax.fromTo('.js-circle-blue-1', 1, {y: 600}, {y: 50, ease: Power0.easeNone}),
        TweenMax.fromTo('.js-circle-yellow-1', 1, {y: -100}, {y: 400, ease: Power0.easeNone}),
    ])));

    registerScene(new ScrollMagic.Scene({
        triggerElement: '.section--blue',
        duration: sectionGetHeight('.section--blue'),
        triggerHook: "onEnter",
    }).setTween(new TimelineMax().add([
        TweenMax.fromTo('.js-circle-orange-2', 1, {y: 0}, {y: 1200, ease: Power0.easeNone}),
        TweenMax.fromTo('.js-circle-green-2', 1, {y: 250}, {y: -1200, ease: Power0.easeNone}),
        TweenMax.fromTo('.js-circle-blue-2', 1, {y: 400}, {y: -500, ease: Power0.easeNone}),
    ])));

    registerScene(new ScrollMagic.Scene({
        triggerElement: '.section--slider',
        duration: sectionGetHeight('.section--slider'),
        triggerHook: "onEnter",
    }).setTween(new TimelineMax().add([
        TweenMax.fromTo('.js-circle-green-cs', 1, {y: -100}, {y: 150, ease: Power0.easeNone}),
        TweenMax.fromTo('.js-circle-blue-cs', 1, {y: 300}, {y: -200, ease: Power0.easeNone}),
        TweenMax.fromTo('.js-circle-yellow-cs', 1, {y: -400}, {y: 120, ease: Power0.easeNone}),
    ])));
});
